import React from 'react';
import Helmet from 'react-helmet';
import Favicon from '../assets/images/favicon.ico';

/**
 * Add common head elements here.
 * Ex. SEO meta tags
 */
const Head = () => (
  <Helmet>
    <link rel="icon" href={Favicon} />
    <link rel="canonical" href={`${process.env.REACT_APP_BASE_URL}${window.location.pathname}`} />

    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'http://www.schema.org',
        '@type': 'WebSite',
        name: 'Search Administrator',
        alternateName:
          'Search Administrator - Enjoy a faster, safer, and better default search experience for Chrome and Firefox',
        url: 'https://www.searchadministrator.com',
        logo: 'https://www.searchadministrator.com/images/search-administrator-logo-48px.png',
        sameAs: [
          'https://www.facebook.com/Search-Administrator-475853249587651',
          'https://twitter.com/SearchAdmin',
        ],
      })}
    </script>
  </Helmet>
);

export default Head;



// WEBPACK FOOTER //
// ./src/components/Head.js